var constants = {
  BEDS_RANGE_MAX: 5,
  BATHS_RANGE_MAX: 5,
  PARKING_RANGE_MAX: 5
};
export default constants;